'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replace, cb) {
    function checkAuth() {
      console.log(store);
      var loaded = (0, _auth.isLoaded)(store.getState());
      // Using isloaded to universally read the user state.
      // As it updates the state based on the cookie set by us manually.
      // const { auth: { user }} = store.getState();
      // console.log(user);
      console.log(loaded);
      if (!loaded) {
        // oops, not logged in, so can't be here!
        replace('/');
      }
      cb();
    }

    checkAuth();
  };

  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Login }),
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: requireLogin },
      _react2.default.createElement(_reactRouter.Route, { path: 'dashboard', component: _containers.Home }),
      _react2.default.createElement(_reactRouter.Route, { path: 'choose-design', component: _containers.Design }),
      _react2.default.createElement(_reactRouter.Route, { path: 'choose-content', component: _containers.Content }),
      _react2.default.createElement(_reactRouter.Route, { path: 'design-view', component: _containers.VEditor }),
      _react2.default.createElement(_reactRouter.Route, { path: 'pricing', component: _containers.Pricing }),
      _react2.default.createElement(_reactRouter.Route, { path: 'design-view/:id', component: _containers.VEditor }),
      _react2.default.createElement(_reactRouter.Route, { path: 'choose-design/:design_template_id', component: _containers.Design })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'logout', component: _containers.Login }),
    _react2.default.createElement(_reactRouter.Route, { path: 'preview', component: _containers.Preview }),
    _react2.default.createElement(_reactRouter.Route, { path: 'survey', component: _containers.Survey }),
    _react2.default.createElement(_reactRouter.Route, { path: 'widgets', component: _containers.Widgets }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1771
// module chunks = 0